app.controller("SmsAuthController", ["$scope", "AuthService", "$state", "$timeout",
    function ($scope, AuthService, $state, $timeout) {
        $scope.userId = AuthService.userId || localStorage.getItem('userId');
        $scope.code;
        $scope.status;
        $scope.errorText;
        $scope.clicked = false;
        $scope.resend = false;

        $scope.show = function () {
            $timeout(function () {
                $scope.resend = true;
            }, 10000);
        };

        $scope.show();

        $scope.showResendBtn = function () {
            $scope.clicked = true;
        };

        $scope.sendNewCode = function () {
            $scope.status = '';
            $scope.clicked = false;
            $scope.resend = false;
            $scope.show();

            AuthService.verifyPhone({
                phone: AuthService.phone,
                userId: AuthService.userId
            }).then(function (res) {
                if (res.sms === 'Success') {
                    $state.go('sms-auth');
                }
                if (res.err === 'No userId or Invalid phone') $state.go('login')
                if (res.err === 'TIMEOUT') {
                    $scope.status = 'error';
                    $scope.errorText = 'სცადეთ მოგვიანებით';
                }
                if (res.err && res.err.ErrorCode === 75) {
                    $scope.status = 'error';
                    $scope.errorText = 'მითითებული ნომერი არ არსებობს';
                }
            }).catch(function (err) {
                console.error(err);
            })
        };
        $scope.goBack = function () {
            if (AuthService.needSmsAuth) {
                AuthService.logout().then(function (data) {
                    $state.go("login");
                });

            } else {
                $state.go("verify-phone");
            }
        };
        $scope.submit = function () {
            $scope.status = '';

            if ($scope.code && $scope.code.length === 4) {
                if (AuthService.needSmsAuth) {
                    AuthService.smsAuth({
                        code: $scope.code
                    }).then(function (res) {
                        if (res === 'Incorrect') {
                            $scope.status = 'error';
                            $scope.errorText = 'SMS კოდი არასწორია!';
                        } else {
                            $state.go("profile");
                        }
                    }).catch(function (err) {
                        console.error(err);
                    })
                } else {
                    AuthService.verifyCode({
                        code: $scope.code,
                        userId: $scope.userId
                    }).then(function (res) {
                        if (res === 'Incorrect') {
                            $scope.status = 'error';
                            $scope.errorText = 'SMS კოდი არასწორია!';
                        } else $state.go("index");
                    }).catch(function (err) {
                        console.error(err);
                    })
                }
            } else {
                $scope.status = 'error';
                $scope.errorText = 'გთხოვთ სწორად მიუთითოთ SMS კოდი';
            }
        }

    }
]);
